import { render, staticRenderFns } from "./DialogCard.vue?vue&type=template&id=dd3c93cc"
import script from "./DialogCard.vue?vue&type=script&lang=ts"
export * from "./DialogCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports